import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import BootstrapInput from '../../shared/BootstrapInput';
import { SErrorLabelWrapTxt, SInputUsernameOrEmailAddress, SWideSubmitBtn } from '../styles/Form.styled';
import { SForm } from '../styles/Form.styled';
import { SInfo } from '../styles/Footer.styled';
import { useAppSelector, useAppDispatch } from '../../../hooks/customHooks';
import { IForgotPasswordRequest } from '../../../api/client';
import { clearErrors, forgotPassword } from '../../../features/authSlice';
import { ForgotPasswordConfirmationRoute } from '../../../common/routes';
import { useNavigate } from 'react-router-dom';
import ButtonsLoaderContainer from '@/presentation/button/ButtonsLoaderContainer';

const ForgotPasswordForm: React.FC = () => {
  const authState = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<IForgotPasswordRequest>();
  const basePath = (window as any).CSG_CONFIG.BASE_PATH;

  useEffect(() => {
    const subscription = watch(() => {
      if (authState.forgotPasswordRequest.errorDetails.userMessage) {
        dispatch(clearErrors());
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, authState.forgotPasswordRequest.errorDetails.userMessage]);

  return (
    <SForm
      onSubmit={handleSubmit((data) => {
        dispatch(
          forgotPassword({
            forgotPasswordRequest: data,
            onSuccessCallback: () => navigate(`/${basePath}/${ForgotPasswordConfirmationRoute}`),
          }),
        );
      })}
    >
      <SInfo id="idEnterUsernameOrEmail">Please enter your username or email address</SInfo>
      <SInfo id="idAssociatedWithYourAccount">associated with your account.</SInfo>
      <br />
      <SInputUsernameOrEmailAddress>
        <BootstrapInput
          label="Username or Email Address"
          isError={authState.forgotPasswordRequest.isModelInvalid ? true : false}
          register={register('usernameOrEmail', {
            required: 'Username or Email Address is required.',
          })}
          errorLabel={errors.usernameOrEmail?.message}
        />
      </SInputUsernameOrEmailAddress>
      <SErrorLabelWrapTxt id="lblForgotPasswordErrorMsg">
        {authState.forgotPasswordRequest.errorDetails.userMessage}
      </SErrorLabelWrapTxt>
      <br />
      <ButtonsLoaderContainer>
        <ButtonsLoaderContainer showLoader={authState.forgotPasswordRequest.isRequestActive}>
          <SWideSubmitBtn id="btnForgotPsswordSubmit" className="hoverable--dark" type="submit">
            Reset Password
          </SWideSubmitBtn>
        </ButtonsLoaderContainer>
      </ButtonsLoaderContainer>
    </SForm>
  );
};

export default ForgotPasswordForm;
